{
  "toast": {
    "analyticsRefreshed": "Analytics refreshed",
    "ruleSaved": "Rule saved",
    "ruleRemoved": "Rule removed",
    "postRescheduled": "Post rescheduled",
    "campaignCreated": "Campaign created",
    "submittedForApproval": "Submitted for approval",
    "channelConnectedSuccessfully": "Channel connected successfully",
    "channelAddedFinishConnectionBelow": "Channel added — finish connection below",
    "connectedDemoMode": "Connected (demo mode)",
    "disconnected": "Disconnected",
    "reconnectStarted": "Reconnect started",
    "replyPublished": "Reply published",
    "commentResolved": "Comment resolved",
    "assigned": "Assigned",
    "replySent": "Reply sent",
    "conversationAssigned": "Conversation assigned",
    "escalatedDeskTicketWorkflowTriggered": "Escalated — Desk ticket workflow triggered",
    "noteSavedForYourTeam": "Note saved for your team",
    "savedReplyAdded": "Saved reply added",
    "inboundMessageSimulated": "Inbound message simulated",
    "published": "Published",
    "connectedInDemoModeRunTestsBelow": "Connected in demo mode — run tests below",
    "allTestsPassed": "All tests passed",
    "diagnosticsComplete": "Diagnostics complete",
    "tokenRefreshAttempted": "Token refresh attempted",
    "notificationPreferencesSaved": "Notification preferences saved",
    "keywordAdded": "Keyword added",
    "folderCreated": "Folder created",
    "uploadComplete": "Upload complete",
    "assetRemoved": "Asset removed",
    "publishRetryCompleted": "Publish retry completed",
    "publishedToConnectedChannels": "Published to connected channels",
    "reviewIngestedSimulatedWebhook": "Review ingested (simulated webhook)",
    "brandCreated": "Brand created",
    "competitorAdded": "Competitor added",
    "integrationCredentialsSaved": "Integration credentials saved",
    "reportExported": "{{reportType}} exported",
    "leadCreated": "Lead #{{id}} created"
  },
  "errors": {
    "analyticsUnavailable": "Analytics unavailable",
    "syncFailed": "Sync failed",
    "exportFailed": "Export failed",
    "failedToLoadAutomationRules": "Failed to load automation rules",
    "failedToSaveRule": "Failed to save rule",
    "failedToDeleteRule": "Failed to delete rule",
    "failedToUpdateRule": "Failed to update rule",
    "calendarUnavailableOnCurrentPlan": "Calendar unavailable on current plan",
    "rescheduleFailed": "Reschedule failed",
    "failedToCreateCampaign": "Failed to create campaign",
    "approvalSubmitFailed": "Approval submit failed",
    "accountNameIsRequired": "Account name is required",
    "couldNotAddChannel": "Could not add channel",
    "connectionFailedSeeSetupGuideForThisNetwork": "Connection failed — see setup guide for this network",
    "disconnectFailed": "Disconnect failed",
    "reconnectFailed": "Reconnect failed",
    "failedToLoadComments": "Failed to load comments",
    "replyFailed": "Reply failed",
    "resolveFailed": "Resolve failed",
    "assignFailed": "Assign failed",
    "couldNotCreateCrmLead": "Could not create CRM lead",
    "selectAConnectedAccount": "Select a connected account",
    "failedToLoadInbox": "Failed to load inbox",
    "failedToLoadMessages": "Failed to load messages",
    "failedToSendMessage": "Failed to send message",
    "assignmentFailed": "Assignment failed",
    "escalationFailed": "Escalation failed",
    "couldNotSaveNote": "Could not save note",
    "simulationFailed": "Simulation failed",
    "failedToLoadPosts": "Failed to load posts",
    "publishFailed": "Publish failed",
    "connectChannelFirst": "Connect channel first",
    "connectionFailed": "Connection failed",
    "testsFailed": "Tests failed",
    "failedToLoadAccounts": "Failed to load accounts",
    "failedToLoadConnectionCenter": "Failed to load connection center",
    "diagnosticsFailed": "Diagnostics failed",
    "tokenRefreshFailedReconnectChannel": "Token refresh failed — reconnect channel",
    "addKeywordFailed": "Add keyword failed",
    "failedToLoadFolders": "Failed to load folders",
    "failedToCreateFolder": "Failed to create folder",
    "uploadFailed": "Upload failed",
    "deleteFailed": "Delete failed",
    "contentAndAtLeastOnePlatformRequired": "Content and at least one platform required",
    "createFailed": "Create failed",
    "publishFailedUseRetryAfterFixingChannelTokens": "Publish failed — use Retry after fixing channel tokens",
    "retryFailedOpenConnectionCenterToRefreshTokens": "Retry failed — open Connection Center to refresh tokens",
    "contentIsRequired": "Content is required",
    "selectAtLeastOneConnectedChannel": "Select at least one connected channel",
    "selectAConnectedChannel": "Select a connected channel",
    "failedToReply": "Failed to reply",
    "failedToCreateBrand": "Failed to create brand",
    "failedToAddKeyword": "Failed to add keyword",
    "failedToAddCompetitor": "Failed to add competitor",
    "failedToSaveIntegration": "Failed to save integration",
    "failedToLoadTeam": "Failed to load team",
    "failedToLoadCampaigns": "Failed to load campaigns",
    "failedToLoadCrmLeads": "Failed to load CRM leads",
    "listeningUnavailableOnCurrentPlan": "Listening unavailable on current plan",
    "failedToLoadMediaLibrary": "Failed to load media library",
    "failedToLoadPublishing": "Failed to load publishing",
    "failedToLoadReviews": "Failed to load reviews"
  },
  "pages": {
    "followersAudience": "Followers / audience",
    "reach": "Reach",
    "engagement": "Engagement",
    "messages": "Messages",
    "responseTime": "Response time",
    "clicks": "Clicks",
    "impressions": "Impressions",
    "leadAttribution": "Lead attribution",
    "liveMonitoring": "Live monitoring",
    "topContent": "Top content",
    "analyticsCenter": "Analytics Center",
    "rankedByEngagementFromSyncedSnapshots": "Ranked by engagement from synced snapshots",
    "crossPlatformPerformanceExportsAndScheduled": "Cross-platform performance, exports, and scheduled reporting",
    "automationCenter": "Automation Center",
    "autoRepliesAssignmentLeadRoutingReview": "Auto-replies, assignment, lead routing, review routing, escalation, and sentiment rules — stored securely per organization",
    "contentCalendar": "Content Calendar",
    "dragPostsBetweenDaysToReschedule": "Drag posts between days to reschedule — auto-publish runs every 30 seconds",
    "socialCampaigns": "Social Campaigns",
    "crossChannelCampaignsLinkedToMarketing": "Cross-channel campaigns linked to Marketing — no duplicate campaign engine",
    "connectedChannels": "Connected channels",
    "addSocialAccount": "Add social account",
    "addMultiplePagesAccountsOrLocations": "Add multiple Pages, accounts, or locations per network under one login",
    "commentsCenter": "Comments Center",
    "replyAssignResolveAndConvertFacebook": "Reply, assign, resolve, and convert Facebook, Instagram, LinkedIn, X, and YouTube comments to CRM leads",
    "engagementTrends": "Engagement trends",
    "platformComparison": "Platform comparison",
    "responsePerformance": "Response performance",
    "crossChannelActivityOverTime": "Cross-channel activity over time",
    "engagementAndClicksByChannel": "Engagement and clicks by channel",
    "averageResponseTimeTrendMinutes": "Average response time trend (minutes)",
    "writtenForBusinessOwnersAndMarketing": "Written for business owners and marketing teams — no technical background required",
    "socialConnectionCenter": "Social Connection Center",
    "connected": "Connected",
    "avgHealth": "Avg health",
    "tokenIssues": "Token issues",
    "webhookIssues": "Webhook issues",
    "connectValidateAndMonitorEverySocial": "Connect, validate, and monitor every social channel — no developer knowledge required",
    "crmLeadsFromSocial": "CRM Leads from Social",
    "leadsCreatedFromInboxCommentsReviews": "Leads created from inbox, comments, reviews, and intake automation",
    "socialCommandCenter": "Social Command Center",
    "getStarted": "Get started",
    "getStartedDescription": "Connect Facebook, Instagram, WhatsApp, LinkedIn, and more — you can add multiple accounts per network.",
    "readSetupGuides": "Read setup guides",
    "addFirstAccount": "Add your first account",
    "publishingCenterLink": "Publishing Center →",
    "connected": "Connected",
    "notConnected": "Not connected",
    "areasCount": "{{count}} areas",
    "additionalMetrics": "Additional metrics",
    "comments": "Comments",
    "reviews": "Reviews",
    "leadsGenerated": "Leads generated",
    "publishedPosts": "Published posts",
    "channelHealth": "Channel health",
    "openComments": "Open comments",
    "todaySWork": "Today's work",
    "connectedPlatforms": "Connected platforms",
    "unifiedSocialInboxPublishingAndAnalytics": "Unified social inbox, publishing, and analytics for your connected accounts",
    "openADedicatedWorkspaceOnlySupported": "Open a dedicated workspace — only supported features appear",
    "unifiedInbox": "Unified Inbox",
    "allChannels": "All channels",
    "facebookInstagramWhatsappTelegramAndAll": "Facebook, Instagram, WhatsApp, Telegram, and all messaging-capable channels in one queue",
    "socialListening": "Social Listening",
    "brandKeywordAndHashtagMatchesAcross": "Brand, keyword, and hashtag matches across connected channels",
    "mediaLibrary": "Media Library",
    "imagesVideosAndCampaignAssetsOrganized": "Images, videos, and campaign assets — organized in folders with search and reuse in Publishing",
    "status": "Status",
    "publishing": "Publishing",
    "notAvailable": "Not available",
    "stories": "Stories",
    "reels": "Reels",
    "mentions": "Mentions",
    "publishingCenter": "Publishing Center",
    "composePost": "Compose post",
    "composeScheduleApproveAndPublishAcross": "Compose, schedule, approve, and publish across connected networks",
    "imagesOrVideoForThisPost": "Images or video for this post",
    "createPost": "Create post",
    "multiChannelPostsWithSchedulingMedia": "Multi-channel posts with scheduling, media, and provider delivery",
    "imagesVideoOrPdf": "Images, video, or PDF",
    "socialAnalytics": "Social Analytics",
    "followers": "Followers",
    "channelPerformanceMonitoringAndCsvExports": "Channel performance, monitoring, and CSV exports",
    "reviewsCenter": "Reviews Center",
    "totalReviews": "Total reviews",
    "open": "Open",
    "replied": "Replied",
    "avgRating": "Avg rating",
    "googleAndFacebookReviewsReplyAssign": "Google and Facebook reviews — reply, assign, track sentiment, and convert to CRM leads",
    "socialSettings": "Social Settings",
    "apiKeysWebhooksBrandsAndShortcuts": "API keys, webhooks, brands, and shortcuts to platform workspaces. Connect channels in Connection Center.",
    "socialSetup": "Social Setup",
    "platformCredentialsMultiBrandListeningAnd": "Platform credentials, multi-brand, listening, and competitor tracking",
    "socialTeams": "Social Teams",
    "assignConversationsAndModerateContentBy": "Assign conversations and moderate content by team member",
    "socialWebhooks": "Social webhooks",
    "configureMetaLinkedinAndOtherNetworks": "Configure Meta, LinkedIn, and other networks to POST inbound events"
  },
  "labels": {
    "ruleName": "Rule name",
    "campaignName": "Campaign name",
    "network": "Network",
    "displayName": "Display name",
    "accountIdOptional": "Account ID (optional)",
    "status": "Status",
    "assignTo": "Assign to",
    "assignAgent": "Assign agent…",
    "writeAPublicReply": "Write a public reply…",
    "simulateInboundDemo": "Simulate inbound (demo)",
    "message": "Message",
    "typeAReply": "Type a reply…",
    "teamOnlyNoteNotSentTo": "Team-only note (not sent to customer)…",
    "sectionTabs": "Section tabs",
    "publishing": "Publishing",
    "inboxDm": "Inbox / DM",
    "comments": "Comments",
    "reviews": "Reviews",
    "analytics": "Analytics",
    "crmIntegration": "CRM integration",
    "selectChannel": "Select channel",
    "addKeyword": "Add keyword",
    "newFolder": "New folder",
    "searchByNameOrTag": "Search by name or tag…",
    "title": "Title",
    "content": "Content",
    "schedule": "Schedule",
    "mediaAttachment": "Media attachment",
    "optionalMediaFile": "Optional media file",
    "scheduleOptional": "Schedule (optional)",
    "mediaOptional": "Media (optional)",
    "attachMediaToThisPost": "Attach media to this post",
    "simulateReviewDemo": "Simulate review (demo)",
    "reviewText": "Review text",
    "rating": "Rating",
    "writeAReply": "Write a reply…",
    "platform": "Platform",
    "appIdClientId": "App ID / Client ID",
    "appSecret": "App secret",
    "webhookVerifyToken": "Webhook verify token",
    "profileName": "Profile name",
    "brandName": "Brand name",
    "keywordOrHashtag": "Keyword or #hashtag"
  },
  "formActions": {
    "saveCredentials": "Save credentials",
    "saveDraftOrSchedule": "Save draft / schedule"
  },
  "listActions": {
    "newPost": "New post",
    "calendar": "Calendar",
    "openMediaLibrary": "Open Media Library",
    "trackCompetitor": "Track competitor",
    "sendTestMessage": "Send test message",
    "simulateWebhook": "Simulate webhook",
    "exportPosts": "Export posts",
    "exportInbox": "Export inbox",
    "refreshData": "Refresh data",
    "refreshToken": "Refresh token",
    "reconnectWizard": "Reconnect wizard",
    "readSetupGuide": "Read setup guide",
    "setupWizard": "Setup wizard",
    "startGuidedSetup": "Start guided setup",
    "openSetupWizard": "Open setup wizard",
    "checkConnectionHealth": "Check connection health",
    "openPublishingCenter": "Open Publishing Center",
    "addAccount": "Add account",
    "addAnotherAccount": "Add another account",
    "addAndConnect": "Add & connect",
    "compose": "Compose"
  }
}
